import { ModulesMap, ModulesConfigMap } from '@/config/data/modulesMaps'
import { _apiRequestWrap } from '../apiService'

function _getIncidentsMyWorksToAdministrateIncidents(options = {}) {
	return _apiRequestWrap(
		ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS,
		ModulesConfigMap[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS].GET_INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS,
		options
	)
}


export default {
	[ModulesConfigMap[ModulesMap.INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS].GET_INCIDENTS_MY_WORKS_TO_ADMINISTRATE_INCIDENTS]: _getIncidentsMyWorksToAdministrateIncidents,

}
